<template>
    <div class="footer-content">
        <div class="content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                บริษัทผู้ให้บริการ : บริษัท เรด ทรี ซอฟท์แวร์ จำกัด
            </div>
            <div class="contact">
                <div class="item" v-for="item in list" :key="item.index">
                    <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                    {{ item.content }}
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2025 ลิขสิทธิ์บริษัท WALLETWAY COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        content: "สายด่วนบริการ: +66 0955421233",
        index: 1,
    },
    {
        content: "อีเมลบริการ: we@wallet-way.com",
        index: 2,
    },
    {
        content: "99/9 หมู่ 2 บางเสาธง 10570 TH",
        index: 3,
    },
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 262px;
    padding: 40px 270px 0;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding: 0 103px 42px;
        box-sizing: border-box;
        border-bottom: 1px solid #999999;

        .title {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #333333;
            line-height: 12px;
            margin-bottom: 21px;

            img {
                width: 45px;
                height: 45px;
                object-fit: cover;
                margin-right: 8px;
            }
        }

        .contact {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .item {
                display: flex;
                align-items: center;
                font-weight: 500;
                font-size: 12px;
                color: #666666;
                line-height: 12px;
                margin-bottom: 18px;

                img {
                    width: 15px;
                    object-fit: cover;
                    margin-right: 8px;
                }
            }
        }
    }

    .bottom {
        margin-top: 16px;
        font-weight: 500;
        font-size: 12px;
        color: #666666;
        line-height: 15px;
        text-align: center;
    }
}
</style>